import { MarkerPillPoint, PillSlot, PillV2Content } from 'types/markerTypesV2/m-v2-core.js';
import { IMarkerV2 } from 'types/markerTypesV2/m-v2-general.js';

export type NormalisedMarkerPillPoint = Omit<IMarkerV2<MarkerPillPoint>, 'view' | 'slots'> & {
  slots: PillSlot[];
};

const viewToSlot = (view: PillV2Content | undefined): PillSlot => ({
  icon: view?.icon,
  theme: view?.theme,
  meta: view?.meta ?? view?.status,
  text: view?.text,
});

export const normalisePill = (marker: IMarkerV2<MarkerPillPoint>): NormalisedMarkerPillPoint => {
  const { view, slots, ...rest } = marker;
  if (view && slots) {
    console.warn('normalisePill: marker has both `view` and `slots` — `slots` wins, `view` discarded.', marker);
  }
  return {
    ...rest,
    hasPoint: view?.hasPoint ?? rest.hasPoint,
    pillClass: view?.pillClass ?? rest.pillClass,
    markerClass: view?.markerClass ?? rest.markerClass,
    slots: slots?.length ? slots : [viewToSlot(view)],
  };
};
